import store from './store';
import uuid from './uuid';
import { getCustomerUuid } from './common-helpers/getCustomerUuid';
import { getHost } from './common-helpers/getHost';
import { setAnswer } from './common-helpers/setAnswer';
import { appendCidToMenuLinks } from './common-helpers/appendCidToMenuLinks';
import { getAnswersData } from './common-helpers/getAnswersData';
import { getPromoCode } from './payments/promo-validity-handler';
import { getDiscountFlow } from './payments/discount-flow';

// always get a fresh csrf token!
if (!!window.performance && window.performance.navigation.type === 2) {
  // value 2 means "The page was accessed by navigating into the history"
  window.location.reload();
}

// refresh the page after one day because there might be a newer version of the site
if (navigator.onLine) {
  setTimeout(function () {
    window.location.reload();
  }, 86400000);
}

const getCurrentPurchaseUuid = function () {
  return getAnswersData('currentPurchaseUuid') ? getAnswersData('currentPurchaseUuid') : getAnswersData('uuid');
};

const setProductsPaid = function (purchased_category, purchased_type) {
  let productsPaid = store.get('productsPaid') || {};

  let product_type = [];

  if (productsPaid[purchased_category]) {
    product_type = productsPaid[purchased_category];
  }

  product_type.push(purchased_type);

  store.appendDiffTypes('productsPaid', { [purchased_category]: product_type });
};

const setCheckoutUrl = function () {
  // This row replaces the customerUuid in the url with the right one, when old customer fill email, and go back to final page
  window.replaceSearchParams('customerUuid', store.getCustomerUuid());

  let getItNowButtons = document.getElementsByClassName('js-get-it-now-button');

  if (getItNowButtons.length) {
    for (let button of getItNowButtons) {
      button.setAttribute('href', window.getCheckoutUrl());
    }
  }
};

const setRightCustomerUuidOnGetItNowButtonWhenLoadFromCache = function () {
  window.addEventListener('pageshow', event => {
    if (event.persisted) {
      setCheckoutUrl();
    }
  });
};

const setPurchasableUuidInGetItNowButton = function () {
  setCheckoutUrl();
};

const removeAnswer = function (key) {
  var answers = store.getAnswers();
  delete answers[key];
  store.set('answers', answers);
};

const removeAnswersData = function () {
  var answers = store.getAnswers();
  delete answers.data;
  store.set('answers', answers);
};

const clearUserData = function () {
  let answers = store.getAnswers();
  let essentialData = ['measurements', 'bodyClass', 'data'];

  for (let key in answers) {
    if (!essentialData.includes(key)) {
      delete answers[key];
    }

    if (key === 'data') {
      delete answers[key].can_generate;
      delete answers[key].measurement;
      delete answers[key].uuid;
      delete answers[key].temporary_code;

      store.set('answers', answers);
    }
  }
};

const urlContainsUUID = function (url = window.location.pathname) {
  const regex = RegExp(window.backEndVars.systemType + `/${uuid.pattern()}`);

  return regex.test(url);
};

const getResendFormVisibility = function (key = null) {
  const resendFormVisibility = store.get('resendFormVisibilityPerDiet') || {};

  return key ? resendFormVisibility[key] : resendFormVisibility;
};

const setResendFormVisibility = function (key, value) {
  let answers = getResendFormVisibility();
  answers[key] = value;

  if (typeof key !== 'string') {
    answers = {};
    for (const [k, v] of Object.entries(key)) {
      answers[k] = v;
    }
  }

  store.set('resendFormVisibilityPerDiet', answers);
};

const setFingerprint = function (fingerprintData) {
  store.set('fingerprint', fingerprintData);
};

const getFingerprint = function () {
  return store.get('fingerprint') ? store.get('fingerprint') : [];
};

const removeFingerprint = function () {
  store.set('fingerprint', []);
};

const setAnswersDataKey = function (key, value) {
  if (!key || !value) {
    return;
  }

  var answers = store.getAnswers();

  if (!answers.data) {
    answers.data = {};
  }

  answers.data[key] = value;
  store.set('answers', answers);
};

const setUUID = function (uuid) {
  if (!uuid) {
    return;
  }

  var answers = store.getAnswers();

  if (!answers.data) {
    answers.data = {};
  }

  answers.data.uuid = uuid;
  store.set('answers', answers);
};

const setCurrentPurchaseUuid = function (currentPurchaseUuid) {
  if (!currentPurchaseUuid) {
    return;
  }

  var answers = store.getAnswers();

  if (!answers.data) {
    answers.data = {};
  }

  answers.data.currentPurchaseUuid = currentPurchaseUuid;
  store.set('answers', answers);
};

const setCurrentCustomerProductUuidWhenOfferIsDownsale = function () {
  if (backEndVars.checkoutOffer == 'downsale') {
    setAnswersDataKey('customer_uuid', backEndVars.customerUuid);
    setAnswersDataKey('uuid', backEndVars.purchasableUUID);
  }
};

const failedPayments = function (paymentMethod, err) {
  const recordedFailures = store.getAnswers().failedPayments || [];

  recordedFailures.push(paymentMethod);
  setAnswer('failedPayments', recordedFailures);
  setAnswer('showPaymentError', err || true);
};

const toDecimal = function (number) {
  return parseFloat(number).toFixed(1);
};

let ua = navigator.userAgent.toLowerCase();
const isAndroidMobile = ua.indexOf('android') > -1 && (ua.indexOf('mobile') > -1 || ua.indexOf('chrome') === -1);
const isAndroidTablet = ua.indexOf('android') > -1 && ua.indexOf('mobile') === -1 && ua.indexOf('x11') === -1;
const isChromeMobileIOS = ua.match('crios');
const isChromeMobileAndroid = ua.indexOf('mobile') > -1 && ua.indexOf('chrome') !== -1;
const isIOSMobile = /ipad|iphone|ipod/.test(ua) && !window.MSStream;
const isMacOS = /macintosh|macintel|macppc|mac68k|macos/.test(ua) && !window.MSStream;

const isNewestIos = function () {
  let osVersion = ua.match(/os (\d{1,})_\d/);

  if (!osVersion) {
    return false;
  }

  return isIOSMobile && osVersion[1] > 11;
};

String.prototype.insertBeforeLastOccurrence = function (strToFind, strToInsert) {
  var n = this.lastIndexOf(strToFind);
  if (n > -1) {
    return this.substring(0, n) + strToInsert + this.substring(n);
  }
};

const isIE10 = navigator.userAgent.match(/MSIE 10/i);
const isIE11 = /Trident.*rv:/.test(navigator.userAgent);

const hasUtmParams = function (queryString) {
  return (
    queryString
      .substring(1)
      .split('&')
      .filter(pair => pair.startsWith('utm')).length != 0
  );
};

const removeMarketingInfo = function () {
  store.remove('marketing');
};

class Url {
  build(...parts) {
    return `${getHost()}/${this._joinWithSlashes(...parts)}`;
  }

  cdn(...parts) {
    return `${this._trimSlashes(backEndVars.cdn)}/${this._joinWithSlashes(...parts)}`;
  }

  redirectTo(...parts) {
    window.location.href = this.build(...parts);
  }

  redirectAfter(location) {
    let _this = this;

    setTimeout(function () {
      window.location.href = _this.build(location);
    }, 3500);
  }

  _ensureString(maybeString) {
    return `${maybeString}`;
  }

  _trimSlashes(maybeString) {
    return this._ensureString(maybeString).replace(/(^\/*|\/*$)/g, '');
  }

  _joinWithSlashes(...parts) {
    return parts.map(part => this._trimSlashes(part)).join('/');
  }
}

const getProviderType = function (provider) {
  let providerType = '';

  switch (provider) {
    case 'stripe':
    case 'stripe-elements':
    case 'stripe-pay-button':
      providerType = 'stripe';
      break;
    case 'paypal-smart-button':
      providerType = 'paypal';
      break;
    case 'braintree':
      providerType = 'braintree';
      break;
    case 'primer':
      providerType = 'primer';
      break;
    case 'adyen':
      providerType = 'adyen';
      break;
    case 'chargebee':
      providerType = 'chargebee';
      break;
  }

  return providerType;
};

const searchPlanDetailsByProviderAndBillingOption = function (planDetails, provider, billingOption) {
  return planDetails.plans.find(
    plan => plan.provider === getProviderType(provider) && plan.billingOptionType === billingOption,
  );
};

const createPaymentInfo = function (details, paymentProvider) {
  // TODO: we can delete properties that are received in details object, because they are not used.
  let priceDetails = searchPlanDetailsByProviderAndBillingOption(
    details.planDetails,
    paymentProvider,
    details.planDetails.type,
  );

  const purchasableDetails = backEndVars.paymentDetails[backEndVars.boxSequence] || backEndVars.paymentDetails;

  return {
    customerUuid: window.getCustomerUuid(),
    purchase: {
      purchasable: {
        id: details.id,
        category: details.category,
        type: details.type,
      },
      bundleProducts: details.bundleProducts,
      finalPrice: {
        amount: purchasableDetails.price
          ? purchasableDetails.price.amount
          : purchasableDetails.planDetails.additionalDetails[0].totalAmount,
        currency: purchasableDetails.price
          ? purchasableDetails.price.currency
          : purchasableDetails.planDetails.additionalDetails[0].currency,
      },
    },
    subscriptionPlan: priceDetails.planId,
    planId: priceDetails.planId,
    planType: details.planDetails['type'],
  };
};

const searchAdditionsDetailsByProvider = function (planDetails, provider) {
  return planDetails.additionalDetails.find(
    additionalDetails => additionalDetails.provider === getProviderType(provider),
  );
};

/**
 * Push data in GTM data layer.
 *
 * @param gtmData
 */
const pushGTMDataLayer = gtmData => {
  window.dataLayer = window.dataLayer || [];
  dataLayer.push(gtmData);
};

/**
 * Track event in GTM.
 *
 * @param events
 */
const trackEventInGTM = (...events) => {
  events.forEach(function (event) {
    if (event.eventType === 'PageView') {
      store.setEventId(event.id);
    } else {
      pushGTMDataLayer({
        event: event.type,
        eventID: event.id,
      });
    }
  });
};

const hasToOpenDiscount = () => {
  const discountPageOpened = localStorage.getItem('discountExpiration');
  const paymentInit = localStorage.getItem('paymentInit');
  const discountSeen = localStorage.getItem('discountSeen');

  return (
    backEndVars.discountData &&
    !backEndVars.discountData.pageIsDiscount &&
    !!backEndVars.discountData.discountSlug &&
    !discountPageOpened &&
    !!paymentInit &&
    !discountSeen
  );
};

const redirectToURL = function (url, selector) {
  if (backEndVars.checkoutOffer === 'downsale') {
    const element = document.querySelector(`.${selector} .js-paypal-loader`);
    element && $t(element).fadeOut();

    const flashModal = document.querySelector('#flash-message-modal');
    if (selector != 'paypal-smart-button') {
      url = flashModal.dataset.redirectUrl;
    }

    flashModal && $t(flashModal).show();
  }

  setTimeout(function () {
    if (url.indexOf('https') == '-1') {
      window.location.href = url;
    } else {
      window.location = url;
    }
  }, 3500);
};

const purchasablePath = function () {
  let url = new URL(window.location.pathname, window.location.origin);
  url.searchParams.append('customerUuid', window.getCustomerUuid());
  url.searchParams.append('uuid', backEndVars.purchasableUUID ?? window.getUuid());

  const promoCode = getPromoCode();
  const discountFlow = getDiscountFlow();

  if (promoCode) {
    url.searchParams.append('promoCode', promoCode);
  }

  if (discountFlow) {
    url.searchParams.append('discountFlow', discountFlow);
  }

  return url.toString();
};

const replaceSearchParams = function (key, value) {
  let url = new URL(window.location.href, window.location.origin);

  if (url.searchParams.has(key)) {
    url.searchParams.set(key, value);
    history.replaceState(null, null, url.toString());
  }
};

const setCustomerUuid = function (customerUuid) {
  this.replaceSearchParams('cid', customerUuid);
  this.replaceSearchParams('customerUuid', customerUuid);

  store.setCustomerUuid(customerUuid);

  if (getAnswersData('customer_uuid')) {
    setAnswersDataKey('customer_uuid', customerUuid);
  }
};

const getUuid = function () {
  let params = new URLSearchParams(window.location.search);

  return params.get('uuid') || params.get('purchasableUuid') || getCurrentPurchaseUuid() || backEndVars.purchasableUUID;
};

const getFinalUrl = function () {
  return window.getHost() + `/final?customerUuid=${getCustomerUuid()}&uuid=${getUuid()}#get-plan`;
};

const redirectToFinalPage = function () {
  window.location.href = getFinalUrl();
};

const getCheckoutUrl = function () {
  return window.getHost() + `/checkout?customerUuid=${getCustomerUuid()}&uuid=${getUuid()}`;
};

const moveToNextUrl = () => {
  let nextUrl = store.get('nextUrl');

  window.location = nextUrl ? nextUrl : '/';
};

const currentProductAlreadyPurchased = () => {
  if (!backEndVars.paymentDetails) {
    return false;
  }

  const purchasableDetails = backEndVars.paymentDetails[backEndVars.boxSequence] || backEndVars.paymentDetails;

  return (
    store.get('productsPaid') &&
    store.get('productsPaid')[purchasableDetails.category] &&
    store.get('productsPaid')[purchasableDetails.category].includes(purchasableDetails.type) &&
    !window.location.href.includes('downsale')
  );
};

export const getQueryParam = key => {
  return new URLSearchParams(window.location.search).get(key);
};

window.clearUserData = clearUserData;
window.createPaymentInfo = createPaymentInfo;
window.failedPayments = failedPayments;
window.getAnswersData = getAnswersData;
window.getCurrentPurchaseUuid = getCurrentPurchaseUuid;
window.getFingerprint = getFingerprint;
window.getHost = getHost;
window.getProviderType = getProviderType;
window.getResendFormVisibility = getResendFormVisibility;
window.hasToOpenDiscount = hasToOpenDiscount;
window.hasUtmParams = hasUtmParams;
window.isAndroidMobile = isAndroidMobile;
window.isAndroidTablet = isAndroidTablet;
window.isChromeMobileIOS = isChromeMobileIOS;
window.isChromeMobileAndroid = isChromeMobileAndroid;
window.isIE10 = isIE10;
window.isIE11 = isIE11;
window.isIOSMobile = isIOSMobile;
window.isMacOS = isMacOS;
window.isNewestIos = isNewestIos;
window.pushGTMDataLayer = pushGTMDataLayer;
window.redirectToURL = redirectToURL;
window.removeAnswer = removeAnswer;
window.removeAnswersData = removeAnswersData;
window.removeFingerprint = removeFingerprint;
window.removeMarketingInfo = removeMarketingInfo;
window.searchAdditionsDetailsByProvider = searchAdditionsDetailsByProvider;
window.searchPlanDetailsByProviderAndBillingOption = searchPlanDetailsByProviderAndBillingOption;
window.setAnswer = setAnswer;
window.setAnswersDataKey = setAnswersDataKey;
window.setCurrentCustomerProductUuidWhenOfferIsDownsale = setCurrentCustomerProductUuidWhenOfferIsDownsale;
window.setCurrentPurchaseUuid = setCurrentPurchaseUuid;
window.setFingerprint = setFingerprint;
window.setPurchasableUuidInGetItNowButton = setPurchasableUuidInGetItNowButton;
window.setResendFormVisibility = setResendFormVisibility;
window.setRightCustomerUuidOnGetItNowButtonWhenLoadFromCache = setRightCustomerUuidOnGetItNowButtonWhenLoadFromCache;
window.setUUID = setUUID;
window.toDecimal = toDecimal;
window.trackEventInGTM = trackEventInGTM;
window.Url = Url;
window.urlContainsUUID = urlContainsUUID;
window.purchasablePath = purchasablePath;
window.replaceSearchParams = replaceSearchParams;
window.getCustomerUuid = getCustomerUuid;
window.setCustomerUuid = setCustomerUuid;
window.getFinalUrl = getFinalUrl;
window.getUuid = getUuid;
window.redirectToFinalPage = redirectToFinalPage;
window.getCheckoutUrl = getCheckoutUrl;
window.setCheckoutUrl = setCheckoutUrl;
window.moveToNextUrl = moveToNextUrl;
window.currentProductAlreadyPurchased = currentProductAlreadyPurchased;
window.appendCidToMenuLinks = appendCidToMenuLinks;
window.setProductsPaid = setProductsPaid;

export {
  clearUserData,
  createPaymentInfo,
  failedPayments,
  getAnswersData,
  getCurrentPurchaseUuid,
  getFingerprint,
  getHost,
  getResendFormVisibility,
  hasToOpenDiscount,
  hasUtmParams,
  isAndroidMobile,
  isChromeMobileIOS,
  isChromeMobileAndroid,
  isIE10,
  isIE11,
  isIOSMobile,
  isMacOS,
  isNewestIos,
  pushGTMDataLayer,
  redirectToURL,
  removeAnswer,
  removeAnswersData,
  removeFingerprint,
  removeMarketingInfo,
  searchAdditionsDetailsByProvider,
  searchPlanDetailsByProviderAndBillingOption,
  setAnswer,
  setAnswersDataKey,
  setCurrentCustomerProductUuidWhenOfferIsDownsale,
  setCurrentPurchaseUuid,
  setFingerprint,
  setPurchasableUuidInGetItNowButton,
  setResendFormVisibility,
  setRightCustomerUuidOnGetItNowButtonWhenLoadFromCache,
  setUUID,
  toDecimal,
  trackEventInGTM,
  Url,
  urlContainsUUID,
  purchasablePath,
  replaceSearchParams,
  getCustomerUuid,
  setCustomerUuid,
  getUuid,
  redirectToFinalPage,
  getCheckoutUrl,
  setCheckoutUrl,
  moveToNextUrl,
  currentProductAlreadyPurchased,
  setProductsPaid,
};
